export default function whereFind() {
  $(".places li").hide();

  $("#select-state").on("change", function() {
    $(".places li").hide();
    const cities = async () =>
      fetch($(this).data("action") + "?id=" + $(this).val()).then((request) =>
        request.json()
      );
    (async () => {
      $(".places li[data-state='" + $(this).val() + "']").show();

      let data = await cities();
      let select = $("#select-city");

      select.empty();
      select.append("<option>Escolha a Cidade</option>");

      $.each(data, function(index, value) {
        let option = $("<option>").text(value.title);
        option.attr("value", value.id);
        select.append(option);
      });

      $("#select-city").append(select);
    })();
  });

  $("#select-city").on("change", function() {
    $(".places li").hide();
    $(".places li[data-city='" + $(this).val() + "']").show();
  });
}
